/*
 * This component was provided by QSIC
 * */
import React, { Component } from 'react';


export type IIcons =
	'facebook' |
	'twitter' |
	'checked' |
	'thanks'
;

interface IProps {
	name: IIcons;
	onClick?: (e?: React.SyntheticEvent<EventTarget>) => void
	color?: string;
	size?: number | string;
	strokeWidth?: number | string;
}

/**
 * SVG components for icons
 */
export class Icon extends Component<IProps, { icon: string, name: string }> {
	private readonly size = 20;
	private readonly strokeWidth = 0;
	/**
	 * @ignore
	 */
	public render() {
		const { color = 'currentColor', size = this.size, strokeWidth = this.strokeWidth, name = 'default_path' } = this.props;
		const icon: any = icons[name];

		return <svg
			viewBox={icon.viewBox}
			strokeWidth={strokeWidth}
			stroke={color}
			color={color}
			fill={color}
			strokeLinecap={'round'}
			width={size}
			height={size}
			dangerouslySetInnerHTML={{__html: icon.d}}
		/>;
	}
}

const icons = {
	'facebook': {
		d: `<path fill="currentColor" d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/>`,
		viewBox: '0 0 264 512'
	},
	'twitter': {
		d: `<path fill="currentColor" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>`,
		viewBox: '0 0 512 512'
	},
	'checked': {
		d: ` <path d="M5.05719096,7.58578644 L12.3500842,0.29289322 L13.7642977,1.70710678 L5.09763107,10.3737735 L5.05719095,10.3333333 L5.01675084,10.3737734 L0.350084177,5.70710678 L1.76429774,4.29289322 L5.05719096,7.58578644 Z" />`,
		viewBox: '0 0 14 11'
	},
	thanks: {
		d: `
			<defs>
                <polygon id="path-1" points="10.5 17 27 0.5 30 3.5 13.5 20 10.5 23 0 12.5 3 9.5"></polygon>
		    </defs>
		    <g id="Phase-2-NewsIQ" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		        <g id="LoveIsland-Phase2-NewsIQ-Step5-(620)" transform="translate(-278.000000, -69.000000)">
		            <g id="UI/Icon-Thanks" transform="translate(280.000000, 71.000000)">
		                <g>
		                    <circle id="Oval" stroke="currentColor" stroke-width="3" cx="30" cy="30" r="30"></circle>
		                    <g id="Group-21" transform="translate(15.000000, 19.000000)">
		                        <mask id="mask-2" fill="white">
		                            <use xlink:href="#path-1"></use>
		                        </mask>
		                        <g id="Clip-20"></g>
		                        <polygon id="Fill-19" fill="currentColor" mask="url(#mask-2)" points="-5 28 35 28 35 -4.5 -5 -4.5"></polygon>
		                    </g>
		                </g>
		            </g>
		        </g>
		    </g>
		`,
		viewBox: '0 0 64 64'
	},
	'default_path': '',

};